import ReactGA from "react-ga4";

ReactGA.initialize("G-5YE3KRLDKQ");
ReactGA.set({ app_name: "romaya_ai" });

export const getPlatform = () => (window.innerWidth < 768 ? "mobile" : "web");

export const trackEvent = (eventName, properties = {}) => {
  const enrichedProperties = {
    ...properties,
    platform: getPlatform(),
  };

  if (import.meta.env.DEV) {
    console.log("[Analytics]", eventName, enrichedProperties);
  }

  ReactGA.event(eventName, enrichedProperties);
};
